import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {
  ReactComponent as ArrowRight
} from '@pagerduty/design-system/dist/icons/android-arrow-forward.svg';
import styles from './index.module.css';

const dateFormatting = { year: 'numeric', month: 'long', day: 'numeric' };

const ModalContentList = props => props.items.map((item, i) => {
  const lastEntry = props.items.length - 1;
  const banner = item.fields.banner && item.fields.banner[0].fields;
  return (
    <React.Fragment key={item.sys.id}>
      <div>
        <time className={styles.caption_text} dateTime={item.fields.date}>
          {new Date(item.fields.date).toLocaleDateString('en-US', dateFormatting)}
        </time>
        <h1 className={banner ? styles.large_title : styles.medium_title}>
          {item.fields.title}
        </h1>
      </div>

      {banner
        && (banner.file.contentType.startsWith('video')
        // eslint-disable-next-line jsx-a11y/media-has-caption,max-len
          ? <video className={styles.modal_banner} src={banner.file.url} type={banner.file.contentType} autoPlay loop playsInline muted />
          : <img className={styles.modal_banner} alt={banner.description} src={banner.file.url} />)
      }

      <div className={styles.regular_text}>
        {documentToReactComponents(item.fields.body)}
      </div>

      {item.fields.link
       && (
       <div>
         <a href={item.fields.link} className={styles.learn_more}>
           Learn more
           <ArrowRight className={styles.arrow_right} />
         </a>
       </div>
       )}
      {i !== lastEntry && <hr className={styles.separator} />}
    </React.Fragment>
  );
});

export default ModalContentList;
